export default String.raw`
<g>
    <rect width="652" height="320" rx="12" class="newsletterBgColor"/>
    <g class="newsletterFont">
        <g id="Frame 675">
            <text xml:space="preserve" style="white-space: pre" font-size="24" font-weight="500" letter-spacing="0px"><tspan x="24" y="56.7273">TRANSLATION_Prv_PopupBanner_Title</tspan></text>
            <g id="Icon Close">
                <use class="bgColorFont" transform="translate(604, 35)" href="#times" width="24" height="24"></use>
            </g>
        </g>
        <g>
            <g id="Frame 253">
                <g>
                    <g id="Interface/Newspaper">
                        <use href="#newspaper" width="32" height="32" transform="translate(24, 96)"></use>
                    </g>
                    <text xml:space="preserve" style="white-space: pre" font-size="14" font-weight="500" letter-spacing="0px"><tspan x="72" y="116.591">TRANSLATION_Prv_NewMagazines</tspan></text>
                </g>
                <g>
                    <g id="Interface/Percent">
                        <use href="#percent" width="32" height="32" transform="translate(24, 148)"></use>
                    </g>
                    <text xml:space="preserve" style="white-space: pre" font-size="14" font-weight="500" letter-spacing="0px"><tspan x="72" y="167.591">TRANSLATION_Prv_UniqueOffers</tspan></text>
                </g>
                <g>
                    <g id="Interface/delivery">
                        <use href="#truck" width="32" height="32" transform="translate(24, 198)"></use>
                    </g>
                    <text xml:space="preserve" style="white-space: pre" font-size="14" font-weight="500" letter-spacing="0px"><tspan x="72" y="218.591">TRANSLATION_Prv_DeliverySchedule</tspan></text>
                </g>
                <g>
                    <g id="Interface/idea">
                        <use href="#lightbulb-on" width="32" height="32" transform="translate(24, 248)"></use>
                    </g>
                    <text xml:space="preserve" style="white-space: pre" font-size="14" font-weight="500" letter-spacing="0px"><tspan x="72" y="269.591">TRANSLATION_Prv_InspirationsAndTips</tspan></text>
                </g>
            </g>
            <g id="Frame 247">
                <text xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="278" y="103.091">TRANSLATION_Prv_JoinNewsletter_A_MobA</tspan><tspan x="278" y="123.091">TRANSLATION_Prv_JoinNewsletter_B_MobB</tspan></text>
                <g id="1. Text Input Basic">
                    <g>
                        <rect x="278.5" y="144.5" width="325" height="39" rx="4.5" class="inputsBgColor bgColorFont--stroke"/>
                        <g id="Interface/Mail">
                            <use class="bgColorFont" href="#envelope" width="24" height="24" transform="translate(294, 152)"></use>
                        </g>
                        <text xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="326" y="169.091">TRANSLATION_Prv_NewsletterInputPlaceholder</tspan></text>
                    </g>
                </g>
                <g id="Frame 263">
                    <g id="Checkbox">
                        <rect id="Base" x="282.5" y="204.5" width="15" height="15" rx="3.5" class="inputsBgColor bgColorFont--stroke"/>
                    </g>
                    <text xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px"><tspan x="318" y="212.364">TRANSLATION_Prv_IAgree_MobA</tspan><tspan x="318" y="228.364">TRANSLATION_Prv_IAgree_MobB</tspan></text>
                </g>
                <g id="Primary button">
                    <rect x="278" y="248" width="326" height="40" rx="5" class="btnSolidBgColor"/>
                    <text class="btnSolidTextColor" xml:space="preserve" style="white-space: pre" font-size="14" font-weight="600" letter-spacing="0px"><tspan x="400.183" y="273.091">TRANSLATION_Prv_SaveMe</tspan></text>
                </g>
            </g>
        </g>
    </g>
</g>
`;